const initMenuAccordions = () => {

    // Get all accordion buttons
    let accordions = document.querySelectorAll(".accordion");

    console.log(accordions.length);

    // Add event listeners to each accordion button
    accordions.forEach(accordion => {
        accordion.addEventListener('click', function(e) {

        e.preventDefault();

        // Toggle the active class to highlight the accordion button
        this.classList.toggle('active');
        
        // Get the next panel (the content that follows the button)
        let panel = this.nextElementSibling;
        
        // Toggle the display of the panel (open/close)
        if (panel.style.display === 'block') {
            panel.style.display = 'none';
            // Change icon to plus when closed
            this.querySelector('.icon').textContent = '+';
        } else {
            panel.style.display = 'block';
            // Change icon to minus when opened
            this.querySelector('.icon').textContent = '−';
        }
        });
    });
    

    document.querySelectorAll('.accordion__trigger').forEach(trigger => {
        trigger.addEventListener('click', function () {
          const targetId = this.getAttribute('data-id');
          const targetElement = document.getElementById(targetId);

          document.querySelectorAll(".accordion__image").forEach(image => {
            image.classList.remove('active');
          });
      
          if (targetElement) {
            targetElement.classList.add('active');
          }
        });
    });
}

export { initMenuAccordions }
